/** 메뉴 제목 — Text 아톰과 같은 규칙: i18n 에 사용자 언어가 있으면 그것, 없으면 name */
export const menuTitle = (
	menu: { name: string; i18n?: { isoLanguageCode: string; title: string }[] },
	language: string,
): string => {
	const hit = (menu.i18n ?? []).find(
		i => i.isoLanguageCode === String(language ?? '').toLowerCase(),
	)
	return hit && hit.title !== '' ? hit.title : menu.name
}
